import React from 'react';
// import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import ButtonsSection from './ButtonsSection';
import HomesResults from './HomesResults';
import sortOptions from '../../components/SortOptions/homes';
import Filters from '../../components/Filters';
import { colors } from '../../styles';

const styles = css`
  padding: 0 5px 70px 5px;
  margin-top: 70px;
  @media(min-width: 992px) {
    padding: 100px 0;
    margin-top: 0;
  }

  .ContentSection_body {
    font-weight: 300;
    font-size: 15px;
    color: ${colors.color3};
    letter-spacing: 0;
    line-height: 28px;
    @media(min-width: 992px) {
      font-size: 17px;
      color: ${colors.text};
      line-height: 30px;
    }
    b {
      font-weight: 700;
    }
    a {
      font-weight: 700;
    }
  }
  .container {
    margin: 0 auto;
  }
`;

class ContentSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[0],
      option: 'New Construction',
    };
    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    this.setState({
      sort,
    });
  }
  toggleOptions = option => {
    if (option !== this.state.option) {
      this.setState({ option });
    }
  }

  render() {
    const { option, sort } = this.state;
    return (
      <div className={styles}>
        <div className="row">
          <ButtonsSection option={option} toggleOptions={this.toggleOptions} />
          <div className="ml-auto">
            <Filters
              type="homes"
              filterOptions={[
              ]}
              sortOnly
              activeSort={sort}
              sortOptions={sortOptions}
              onSortSelect={this.setSort}
            />
          </div>
          <div className="col-12 px-0">
            <HomesResults sort={sort} option={option} toggleOptions={this.toggleOptions} />
          </div>
        </div>
      </div>
    );
  }
}

ContentSection.propTypes = {
};

ContentSection.defaultProps = {
};
export default ContentSection;



// WEBPACK FOOTER //
// ./src/pages/Homes/ContentSection.js